<mat-card class="default">
  <mat-card-title>
    <span translate="patient-intake.welcome.title"></span>
  </mat-card-title>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <a
        (click)="openTerms()"
        translate="patient-intake.welcome.terms-of-use"
      ></a>
      <mat-icon [ngClass]="acceptedTerms ? 'green' : 'red'"
        >assignment_turned_in</mat-icon
      >
    </div>
    <div *ngIf="consents && consents.length > 0">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        *ngFor="let consent of consents"
      >
        <a (click)="openConsents(consent)">{{ consent.title | translate }}</a>
        <mat-icon
          [ngClass]="consented && consented[consent.id] ? 'green' : 'red'"
          >assignment_turned_in</mat-icon
        >
      </div>
    </div>
  </mat-card-content>
</mat-card>
